<template>
  <div class="min-w-24 ml-2">
    <label
      v-if="fieldLabel"
      :for="fieldPath"
      class="block text-sm/6 font-medium text-gray-900 sm:pt-1.5"
    >
      {{ fieldLabel }}
    </label>
    <div class="relative">
      <input
        data-1p-ignore
        :value="modelValue"
        @input="onInput($event)"
        v-bind="fieldAttrs"
        type="text"
        inputmode="decimal"
        :name="fieldPath"
        :id="fieldPath"
        maxlength="7"
        class="block w-full rounded-md bg-white pr-7 pl-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6 invalid:outline-red-600 invalid:focus:outline-red-600"
      />
      <span
        class="absolute inset-y-0 right-2 flex items-center text-gray-500 text-sm pointer-events-none"
      >
        %
      </span>
    </div>
    <p v-if="errors[fieldPath]" class="text-sm text-red-600">
      {{ errors[fieldPath] }}
    </p>
  </div>
</template>

<script setup>
defineProps(["modelValue", "fieldPath", "fieldAttrs", "fieldLabel", "errors"]);
const emit = defineEmits(["update:modelValue"]);

const onInput = (event) => {
  let val = event.target.value;

  val = val.replace(/[^0-9.]/g, "");

  const parts = val.split(".");
  if (parts.length > 2) {
    val = parts[0] + "." + parts.slice(1).join("");
  }

  if (val.length > 7) {
    val = val.slice(0, 6);
  }

  emit("update:modelValue", val);
};
</script>
